import {LocaleInfoModel} from "../components/localization/interface";
import api from "../../services/api";
import {apiUrl} from "../../services/apiUrl";
import {useEffect, useState} from "react";
import {getLanguageFromLocaleCode} from "../localization/localizationHelper";
import {AppInfo, AppInfoServer} from "./interface";
import LogoUsageTypeMapEnum from "./enums/LogoUsageTypeMapEnum";
import {defaultCountryCode, defaultLanguageCode, defaultLocalCode, defaultLocale} from "../localization/defaults";

const DefualtAppInfo: AppInfo = {
    project: {
        id: -1,
        name: "His",
        logoSizeType: "Landscape",
        title: "Hospital Information System",
        logoUsageType: LogoUsageTypeMapEnum.InstanceWithValue(1),
        supportredLocales: [defaultLocale],
        owner: {
            id: -1,
            name: "",
            logoSizeType: "Landscape",
        }, partner: {
            id: -1,
            name: "",
            logoSizeType: "Landscape",
        },
        locale: defaultLocalCode,
        type: "HIS",
        version: {
            major: 1,
            minor: 0,
            build: 241012,
            revision: 0
        }
    },
    customer: {
        id: 0,
        name: "",
        countryCode: defaultCountryCode
    }
}
const AppInfoGetter = () => {


    const [appModel, setAppModel] = useState<AppInfo>();
    useEffect(() => {
        (async () => {
            try {
                if (appModel === undefined || appModel?.project?.id === 0) {
                    const response = await api.get(apiUrl.yonetim.application + "getApplicationInfo");
                    if (response?.data?.data) {
                        const appModelServer = response.data.data as AppInfoServer;
                        const {supportedLanguages, logoUsageType, partner, owner, ...baseProjectProps} = appModelServer.project;
                        const LocaleInfoList: LocaleInfoModel[] = supportedLanguages.map<LocaleInfoModel>(
                            (supportedLanguage) => {
                                return {
                                    locale: supportedLanguage.languageTag ?? defaultLocalCode,
                                    displayLanguage: supportedLanguage.displayLanguage ?? defaultLanguageCode,
                                    rtl: supportedLanguage.rtl ?? false,
                                    languageCode: getLanguageFromLocaleCode(supportedLanguage.languageTag) ?? defaultLanguageCode,
                                    localeDateTimeFormat: supportedLanguage.longDateFormat ?? "",
                                    timeFormat: supportedLanguage.timeFormat ?? "",
                                    localeDateFormat: supportedLanguage.shortDateFormat ?? "",
                                    name: supportedLanguage.displayLanguage ?? "",
                                    icon: supportedLanguage.countryCode.toLocaleLowerCase(),
                                    countryCode: supportedLanguage.countryCode
                                }

                            })

                        const logoSizeTypeProject: "Landscape" | "Portrait" | "Square" = (() => {
                            if (baseProjectProps && baseProjectProps.id !== undefined) {

                                switch (baseProjectProps.id) {
                                    case 7:
                                        return "Square";
                                    default:
                                        return "Landscape"; // 1.91:1
                                }
                            } else {
                                return "Landscape"
                            }
                        })();
                        const findComponyLogoSizeType = (prop?: { id?: number, name: string }) => {
                            if (prop != undefined && prop.id !== undefined) {

                                switch (prop.id) {
                                    case 6:
                                        return "Square";
                                    default:
                                        return "Landscape"; // 1.91:1
                                }
                            } else {
                                return "Landscape"
                            }
                        }
                        const logoSizeTypePartner: "Landscape" | "Portrait" | "Square" = findComponyLogoSizeType(partner);
                        const logoSizeTypeOwner: "Landscape" | "Portrait" | "Square" = findComponyLogoSizeType(owner)
                        const appModel: AppInfo = {
                            customer: appModelServer.customer,
                            project: {
                                supportredLocales: LocaleInfoList,
                                logoUsageType: LogoUsageTypeMapEnum.InstanceWithValue(logoUsageType),
                                logoSizeType: logoSizeTypeProject,
                                partner: {...partner, ...{logoSizeType: logoSizeTypePartner}},
                                owner: {...owner, ...{logoSizeType: logoSizeTypeOwner}},
                                ...baseProjectProps
                            }

                        }
                        setAppModel(appModel);
                    } else {
                        setAppModel(DefualtAppInfo);
                    }


                }
            } catch (e) {
                console.log(e);
            }

        })();
        // eslint-disable-next-line
    }, [])

    return appModel;
}
AppInfoGetter.Default = DefualtAppInfo;
export default AppInfoGetter;





